skrilla.controller('changePasswordCtrl', function ($scope, $http, envService, loginService) {
    $scope.change = function () {
        if($scope.update.newPassword === $scope.confirmNewPassword){
            $http.post(envService.read('loginUrl') + "update-password", $scope.update).then(function(response){
               loginService.login({email: $scope.update.email, password: $scope.update.newPassword, mfaToken: $scope.update.mfaToken});
            }, function(response){
                swal("Error!", response.data.errors[0].message)
            });
        }
        else{
            alert("New passwords must match!");
        }
    }
    $scope.btnPress = function (keyEvent) {
        if (keyEvent.which === 13)
            $scope.change();
    }
});

